<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
  },
};
</script>

<style lang="scss">
// 引入苹方字体
  @font-face{
  font-family:'PingFang SC-Regular';
    src: url('./assets/fonts/PingFangRegular.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
    
  }  
  @font-face{
    font-family:'PingFang SC-Semibold';
    src: url('./assets/fonts/PingFangSemibold.ttf') format('truetype');

    font-weight: normal;
    font-style: normal;
  }
 
  @font-face{
    font-family:'PingFang SC-Medium';
     src: url('./assets/fonts/PingFangMedium.ttf') format('truetype');

  }
*{
    margin: 0;
    padding: 0;
    list-style: none;
}
#app{
 background:rgba(246,246,246,1);
 width: 100%;
 .main{
     padding:40px 60px 45px 60px;
     box-sizing: border-box;
    //  background-color: red;
     min-height: calc(100vh - 107px);
 }
}
</style>



// WEBPACK FOOTER //
// src/App.vue